export default __webpack_public_path__ + "static/media/logo-ias.6bcc6146.png";